import { Controller } from "@hotwired/stimulus";
import Tagify from "@yaireo/tagify";
import "@yaireo/tagify/dist/tagify.css";

export default class extends Controller {
  connect() {
    this.tagify = new Tagify(this.element, {
      originalInputValueFormat: (valuesArr) =>
        valuesArr.map((item) => item.value).join(","),
    });
  }

  disconnect() {
    if (this.tagify) {
      this.tagify.destroy();
    }
  }
}
